export default __webpack_public_path__ + "static/media/logo.2b85c528.png";